import Message from '@/lib/message';
import { getNuvemshopData } from './nuvemshop.service';

export default {
  checkoutCustomConfig: {
    showCCBText: true,
  },
  preQualifyEventHandler: {
    onReady() {
      Message.post({ ev: 'ready' });
    },
    onSendPreQualifyId(data) {
      Message.post({ ev: 'sendPreQualifyId', data });
    },
    onError() {
      Message.post({ ev: 'error' });
    },
    onVerify(data) {
      Message.post({ ev: 'verifyCredit', data });
    },
    onGoToCheckout() {
      Message.post({ ev: 'modalGoToCheckout' });
    },
    onClosed() {
      Message.post({ ev: 'modalClose' });
    },
  },
  utilFunctions: {
    async getCheckoutData({ orderObjectId, apiKey, hashData }) {
      const nuvemshopResponse = await getNuvemshopData({ orderObjectId, apiKey, hashData });

      const order = nuvemshopResponse && nuvemshopResponse.data.order;
      if (!order) throw new Error('Order not found');

      return {
        ...order,
        checkoutUrl: order.callbackUrls.cancel,
      };
    },
  },
};
